import { Typography } from "@/design-system/Atoms";
import { HowItWorksStepCard } from "@/design-system/Molecules";
import { OralMedWhyDefyMedStepCardData } from "@/design-system/Molecules/HowItWorksStepCard/stepCard.config";

export const OralMedWhyDefyMedSection = () => {
  return (
    <section className="relative block pt-44 lg:pt-[176px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-5/12">
            <Typography variant="categoryText" as="div" className="mb-10">
              Defy Benefits
            </Typography>
            <Typography variant="sectionHeading" as="h2" className="mb-10">
              <>
                The Defy{" "}
                <span className="text-gray-400">Medical Difference</span>
              </>
            </Typography>
            <Typography
              variant="sectionDescriptionLarge"
              as="p"
              className="mb-10"
            >
              At Defy Medical, we’re redefining Men’s Health with personalized
              care and expert solutions. We’re committed to providing you with
              safe, effective treatments tailored to your lifestyle.
            </Typography>

            {OralMedWhyDefyMedStepCardData.map((step, idx) => (
              <HowItWorksStepCard
                key={idx}
                icon={step.icon ?? ""}
                title={step.title ?? ""}
                description={step.description ?? ""}
                className={step.className ?? ""}
              />
            ))}
          </div>
          <div className="w-full lg:w-1/2  lg:ml-[8.333333%]">
            <div className="sticky top-0 mb-[3.125rem]">
              <div>
                <img
                  className="w-full object-cover"
                  src="/images/oralmed/img-whydefy.png"
                  alt="oral-med-why"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OralMedWhyDefyMedSection;
